import Vue from 'vue/dist/vue.esm'

Vue.component('international-legislation-index-vue', () =>
  import(/* webpackChunkName: "[request]" */ 'components/international_legislation/Index.vue')
)


